import script from "./UDropFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDropFilters.vue?vue&type=script&setup=true&lang=ts"

import "./UDropFilters.vue?vue&type=style&index=0&id=71de40a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71de40a7"]])

export default __exports__